module.exports = __webpack_public_path__ + "img/c24.f998580b.png";